import React, { useEffect, useState } from "react"
import {
  Button,
  Card,
  CardBody,
  Form,
  Input,
  Label,
  Row,
  Col,
} from "reactstrap"
import Select from "react-select"
import QrCode from "../../../assets/images/PULA-QR-code.png"
import { useLocation, useNavigate } from "react-router-dom"
import { useDispatch, useSelector } from "react-redux"
import {
  addBookingPayment,
  fetchBookingDetails,
} from "../../../redux/actions/pvs"
import { useFormik } from "formik"
import { toast } from "react-toastify"
import { ADD_BOOKING_PAYMENT_RESET } from "../../../redux/types/pvs"
import moment from "moment"
import ErrorPopup from "components/ErrorPopup"
import PageLoader from "components/Common/PageLoader"
import * as Yup from "yup"

const paymentOptions = [
  { value: "UPI", label: "UPI" },
  { value: "Bank_Transfer", label: "Bank Transfer" },
  { value: "Cash", label: "Cash" },
]

const useQuery = () => new URLSearchParams(useLocation().search)
const BazaarPayment = () => {
  const query = useQuery()
  const registrationId = query.get("id")

  const dispatch = useDispatch()
  const navigate = useNavigate()

  const [customActiveTab, setcustomActiveTab] = useState("1")
  const [selectedGroup, setselectedGroup] = useState(null)
  const [selectedStateGroup, setselectedStateGroup] = useState(null)
  const [selectedRegionGroup, setselectedRegionGroup] = useState(null)
  const [selectedSeller, setselectedSeller] = useState(null)
  const [selectedPayment, setSelectedPayment] = useState("")
  const [amount, setAmount] = useState("")
  const [transactionId, setTransactionId] = useState("")
  const [payments, setPayments] = useState([])
  const [stalls, setStalls] = useState([])
  const [payableTotal, setPayableTotal] = useState(0)
  const [addedAmount, setAddedAmount] = useState(0)
  const [isErrorOpen, setIsErrorOpen] = useState(false)
  const [isErrorMessage, setIsErrorMessage] = useState("")

  const toggleCustom = tab => {
    if (customActiveTab !== tab) {
      setcustomActiveTab(tab)
    }
  }

  const token = useSelector(state => state.auth.token)
  const bookingInfo = useSelector(state => state.pvs.bookingInfo)
  const addBookingPaymentScreen = useSelector(
    state => state.screens.pvs.addBookingPayment
  )

  useEffect(() => {
    if (addBookingPaymentScreen.success) {
      toast.success(addBookingPaymentScreen.message)
      dispatch({ type: ADD_BOOKING_PAYMENT_RESET })
      navigate(-1)
    }
    if (addBookingPaymentScreen.error) {
      // toast.error(addBookingPaymentScreen.error)
      setIsErrorMessage(addBookingPaymentScreen.error)
      setIsErrorOpen(true)
      dispatch({ type: ADD_BOOKING_PAYMENT_RESET })
    }
  }, [addBookingPaymentScreen])

  useEffect(() => {
    dispatch(
      fetchBookingDetails({ enc_bazaar_register_id: registrationId }, token)
    )
  }, [])

  const handlePaymentChange = selectedOption => {
    setSelectedPayment(selectedOption?.value || "")
  }
  const handleSelectGroup = selectedGroup => {
    setselectedGroup(selectedGroup)
  }
  const handleStateGroup = selectedStateGroup => {
    setselectedStateGroup(selectedStateGroup)
  }
  const handleRegionGroup = selectedRegionGroup => {
    setselectedRegionGroup(selectedRegionGroup)
  }
  const cityOptions = [
    {
      options: [
        { label: "Pune", value: "Pune" },
        { label: "Mumbai", value: "Mumbai" },
        { label: "Delhi", value: "Delhi" },
        { label: "Bangalore", value: "Bangalore" },
        { label: "Chennai", value: "Chennai" },
        { label: "Kolkata", value: "Kolkata" },
      ],
    },
  ]
  const stateOptions = [
    {
      options: [
        {
          label: "Andaman and Nicobar Islands",
          value: 4023,
        },
        {
          label: "Andhra Pradesh",
          value: 4017,
        },
        {
          label: "Arunachal Pradesh",
          value: 4024,
        },
        {
          label: "Assam",
          value: 4027,
        },
        {
          label: "Bihar",
          value: 4037,
        },
        {
          label: "Chandigarh",
          value: 4031,
        },
        {
          label: "Chhattisgarh",
          value: 4040,
        },
        {
          label: "Dadra and Nagar Haveli and Daman and Diu",
          value: 4033,
        },
        {
          label: "Delhi",
          value: 4021,
        },
        {
          label: "Goa",
          value: 4009,
        },
        {
          label: "Gujarat",
          value: 4030,
        },
        {
          label: "Haryana",
          value: 4007,
        },
        {
          label: "Himachal Pradesh",
          value: 4020,
        },
        {
          label: "Jammu and Kashmir",
          value: 4029,
        },
        {
          label: "Jharkhand",
          value: 4025,
        },
        {
          label: "Karnataka",
          value: 4026,
        },
        {
          label: "Kerala",
          value: 4028,
        },
        {
          label: "Ladakh",
          value: 4852,
        },
        {
          label: "Lakshadweep",
          value: 4019,
        },
        {
          label: "Madhya Pradesh",
          value: 4039,
        },
        {
          label: "Maharashtra",
          value: 4008,
        },
        {
          label: "Manipur",
          value: 4010,
        },
        {
          label: "Meghalaya",
          value: 4006,
        },
        {
          label: "Mizoram",
          value: 4036,
        },
        {
          label: "Nagaland",
          value: 4018,
        },
        {
          label: "Odisha",
          value: 4013,
        },
        {
          label: "Puducherry",
          value: 4011,
        },
        {
          label: "Punjab",
          value: 4015,
        },
        {
          label: "Rajasthan",
          value: 4014,
        },
        {
          label: "Sikkim",
          value: 4034,
        },
        {
          label: "Tamil Nadu",
          value: 4035,
        },
        {
          label: "Telangana",
          value: 4012,
        },
        {
          label: "Tripura",
          value: 4038,
        },
        {
          label: "Uttar Pradesh",
          value: 4022,
        },
        {
          label: "Uttarakhand",
          value: 4016,
        },
        {
          label: "West Bengal",
          value: 4853,
        },
      ],
    },
  ]
  const regionOptions = [
    {
      options: [
        {
          label: "North Pune (Aundh, Baner, Wakad, Hinjewadi, Pimple Saudagar)",
          value: "North Pune",
        },
        {
          label: "South Pune (Katraj, Kondhwa, Undri, Bibwewadi, Mohammedwadi)",
          value: "South Pune",
        },
        {
          label:
            "East Pune (Viman Nagar, Kharadi, Kalyani Nagar, Lohegaon, Wagholi)",
          value: "East Pune",
        },
        {
          label:
            "West Pune (Kothrud, Bavdhan, Warje, Karve Nagar, Sinhagad Road)",
          value: "West Pune",
        },
        {
          label:
            "Central Pune (Camp, Deccan, Shivajinagar, Swargate, Sadashiv Peth)",
          value: "Central Pune",
        },
      ],
    },
  ]

  useEffect(() => {
    if (bookingInfo) {
      const selectedSellerTemp = bookingInfo.billing_details.find(
        val => val.seller_type === "seller_1"
      )
      if (selectedSellerTemp) {
        setselectedSeller(selectedSellerTemp)
        billingDetails.setValues({
          customerType: selectedSellerTemp.seller_type || "seller_1",
          firstName: selectedSellerTemp.billing_first_name || "",
          lastName: selectedSellerTemp.billing_last_name || "",
          companyName: selectedSellerTemp.billing_company_name || "",
          address: selectedSellerTemp.billing_address || "",
          city: selectedSellerTemp.billing_city || "Pune",
          state: selectedSellerTemp.billing_state
            ? stateOptions[0].options.find(
                val => val.label === selectedSellerTemp.billing_state
              )
            : stateOptions[0].options[20],
          pincode: selectedSellerTemp.billing_pincode || "",
          gstNumber: selectedSellerTemp.billing_gst_number || "",
          email: selectedSellerTemp.billing_email_id || "",
          mobileNo: selectedSellerTemp.billing_mobile_no || "",
        })
      }

      let tempCheckedStalls = []
      bookingInfo.payable_amount.stalls.map(val => {
        if (val.payment_status === "pending") {
          tempCheckedStalls.push(val)
        }
      })
      tempCheckedStalls.map((value, index) => {
        tempCheckedStalls[index] = {
          ...value,
          checked:
            value.pvs_card_number ===
            bookingInfo.bazaar_registration.pvs_card_number,
          stall_cost: value.stall_cost + value.add_on_cost,
        }
      })
      setStalls(tempCheckedStalls)
    }
  }, [bookingInfo])

  useEffect(() => {
    let grandTotal = 0
    stalls.map(val => {
      if (val.checked && val.payment_status === "pending") {
        grandTotal += val.subtotal
      }
    })
    setPayableTotal(grandTotal)
  }, [stalls])

  useEffect(() => {
    paymentInfo.setFieldValue(
      "amount",
      payableTotal - payments.reduce((sum, val) => sum + Number(val.amount), 0)
    )
  }, [payableTotal, payments])

  useEffect(() => {
    let grandTotal = 0
    payments.map(val => {
      grandTotal += Number(val.amount)
    })
    setAddedAmount(grandTotal)
  }, [payments])

  const sellerTypeChange = value => {

    const selectedSellerTemp = bookingInfo.billing_details.find(
      val => val.seller_type === value
    )
    setselectedSeller(selectedSellerTemp)
    billingDetails.setValues({
      customerType: selectedSellerTemp.seller_type || "seller_1",
      firstName: selectedSellerTemp.billing_first_name || "",
      lastName: selectedSellerTemp.billing_last_name || "",
      companyName: selectedSellerTemp.billing_company_name || "",
      address: selectedSellerTemp.billing_address || "",
      city: selectedSellerTemp.billing_city || "Pune",
      state: selectedSellerTemp.billing_state
        ? stateOptions[0].options.find(
            val => val.label === selectedSellerTemp.billing_state
          )
        : stateOptions[0].options[20],
      pincode: selectedSellerTemp.billing_pincode || "",
      gstNumber: selectedSellerTemp.billing_gst_number || "",
      email: selectedSellerTemp.billing_email_id || "",
      mobileNo: selectedSellerTemp.billing_mobile_no || "",
    })
  }

  const changeCheckedStalls = index => {
    let tempStalls = [...stalls]
    tempStalls[index] = {
      ...tempStalls[index],
      checked: !tempStalls[index].checked,
    }
    setStalls(tempStalls)
  }

  const handleStallDiscount = (index, discountPer) => {

    let tempStalls = [...stalls]
    let discountAmount = 0
    let stallCost = 0
    let gstAmount = 0
    let subtotal = 0
    discountAmount =
      tempStalls[index].base_price -
      tempStalls[index].base_price * (discountPer / 100)
    discountAmount = Math.floor(discountAmount)
    stallCost = discountAmount
    if (tempStalls[index].two_sides_price > 0) {
      stallCost = discountAmount + tempStalls[index].two_sides_price
    }
    if (tempStalls[index].add_on_cost > 0) {
      stallCost += tempStalls[index].add_on_cost
    }

    gstAmount = Math.floor(stallCost * (18 / 100))

    subtotal = stallCost + gstAmount
    tempStalls[index] = {
      ...tempStalls[index],
      discount_percent: discountPer.toString(),
      discount_amount: discountAmount,
      stall_cost: stallCost,
      gst: gstAmount,
      subtotal: subtotal,
    }
    setStalls(tempStalls)
  }

  const addPayment = () => {}

  const removePayment = index => {
    let tempPayment = [...payments]
    if (index >= 0 && index < tempPayment.length) {
      tempPayment.splice(index, 1)
      setPayments(tempPayment)
    }
  }

  // simple validators
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
  const phoneRegex = /^[6-9]\d{9}$/
  // GSTIN (15 chars) regex — 2 digits (state) + 10-char PAN + 1 entity char + 'Z' + checksum
  const gstRegex = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z][1-9A-Z]Z[0-9A-Z]$/i
  // URL / link validator (allows optional http(s), domain (or localhost), optional port and path/query/fragment)
  const linkRegex =
    /^(https?:\/\/)?((([a-zA-Z0-9-]{1,63}\.)+[a-zA-Z]{2,63})|localhost)(:\d{1,5})?(\/[^\s]*)?$/i

  const billingDetails = useFormik({
    initialValues: {
      customerType: "seller_1",
      firstName: "",
      lastName: "",
      companyName: "",
      address: "",
      city: "Pune",
      state: stateOptions[0].options[20],
      pincode: "",
      gstNumber: "",
      email: "",
      mobileNo: "",
    },
    validationSchema: Yup.object({
      gstNumber: Yup.string().matches(gstRegex, "Invalid GST Number"),
    }),
    onSubmit: values => {

      if (payableTotal != addedAmount) {
        // toast.error(
        //   `Total payment mismatch. Expected ₹${payableTotal}, but got ₹${addedAmount}`
        // )
        setIsErrorMessage(
          `Total payment mismatch. Expected ₹${payableTotal}, but got ₹${addedAmount}`
        )
        setIsErrorOpen(true)
        return
      }
      if (payments.length > 0) {
        let stallAmount = []
        let encRegistrationIds = []
        let registraionIds = [] // only for check duplicate ids, don't pass in api.
        stalls.map(value => {
          if (value.checked && value.payment_status === "pending") {
            if (!registraionIds.includes(value.bazaar_register_id)) {
              encRegistrationIds.push(value.enc_bazaar_register_id)
              registraionIds.push(value.bazaar_register_id)
              stallAmount.push({
                enc_bazaar_register_id: value.enc_bazaar_register_id,
                base_price: value.base_price,
                two_sides_price: value.two_sides_price,
                discount_percent: value.discount_percent, //0%
                stall_cost: value.stall_cost - value.add_on_cost, //24000 +  4000 =  28000
                subtotal: value.subtotal, // base_price - discountAmt (optional) + two_sided_price + add_on_cost
              })
            }
          }
        })
        let requestBody = {
          enc_bazaar_register_ids: encRegistrationIds,
          stall_amount: stallAmount,
          payment_billing: {
            first_name: values.firstName,
            last_name: values.lastName,
            email_id: values.email,
            mobile_no: values.mobileNo,
            gst_number: values.gstNumber,
            company_name: values.companyName,
            // region: "Kharadi",
            address: values.address,
            city: values.city,
            state: values.state ? values.state.label : "",
            pincode: values.pincode,
          },
          payment_by: payments,
        }

        dispatch(addBookingPayment(requestBody, token))
      } else {
        toast.error("No payments have been added")
      }

      // dispatch(updateUser(requestData, token))
    },
  })

  const paymentInfo = useFormik({
    initialValues: {
      payment_method: paymentOptions.find(val => val.value === "UPI"),
      amount:
        payableTotal -
        payments.reduce((sum, val) => sum + Number(val.amount), 0),
      transaction_id: "",
    },
    validate: values => {
      const errors = {}
      if (!values.payment_method) errors.payment_method = "Required"
      if (!values.amount) errors.amount = "Required"
      // if (
      //   (values.payment_method.value === "Bank_Transfer" ||
      //     values.payment_method.value === "UPI") &&
      //   !values.transaction_id
      // )
      //   errors.transaction_id = "Required"

      return errors
    },
    onSubmit: values => {
      let tempPayment = [...payments]
      tempPayment.push({
        payment_method: values.payment_method.value,
        amount: values.amount.toString(),
        transaction_id: values.transaction_id,
      })
      let grandTotal = 0
      tempPayment.map(val => {
        grandTotal += Number(val.amount)
      })
      if (grandTotal > payableTotal) {
        setIsErrorMessage(
          `Total is suming up to ₹${grandTotal} which is more than payable amount ₹${payableTotal}`
        )
        setIsErrorOpen(true)
      } else {
        setPayments(tempPayment)
        paymentInfo.setValues({
          payment_method: values.payment_method,
          amount: "",
          transaction_id: "",
        })
      }
    },
  })

  document.title = "Bazaar Payment | PULA"
  return bookingInfo ? (
    <div className="page-content">
      <div className="container-fluid">
        <div className="mb-4">
          <div className="d-flex justify-content-end">
            {/* <span className="delete">
              <i className="dripicons-trash"></i>
            </span> */}
          </div>
        </div>
        <Form onSubmit={billingDetails.handleSubmit}>
          <div className="row">
            <div className="col-12 col-sm-12 col-lg-12">
              <Card>
                <CardBody>
                  <h4 className="nom-title">Booking Details</h4>
                  <div className="border-top mb-3 pb-2"></div>
                  <Row className="align-items-center">
                    <Col md={12}>
                      <Row className="align-items-center">
                        {(() => {
                          // 🔹 Example Data (replace with dynamic data)
                          const sellerName =
                            bookingInfo.bazaar_registration.seller_name
                          const pvsCardNumber =
                            bookingInfo.bazaar_registration.pvs_card_number
                          const stallType =
                            bookingInfo.bazaar_registration.stall_category
                          const sharedWith =
                            bookingInfo.bazaar_registration.sharing_with.join(
                              ", "
                            )
                          // const sharedWith = bookingInfo.bazaar_registration.sharing_with.reduce((sum, val) => sum + `${val}, `, "").toLocaleString()
                          const stallNumber = ""
                          const stallCost =
                            bookingInfo.bazaar_registration
                              .stall_total_without_gst
                          const gstPercent =
                            bookingInfo.bazaar_registration.gst_percent
                          const addOnCost =
                            bookingInfo.bazaar_registration.addon_total

                          const bookingDate = moment(
                            bookingInfo.bazaar_registration.created_at
                          ).format("Do MMM YYYY")
                          const bookedBy =
                            bookingInfo.bazaar_registration.created_by_name

                          // 🔹 Calculations
                          // const gstAmount = (stallCost * gstPercent) / 100
                          // let totalBeforeShare =
                          //   stallCost + gstAmount + addOnCost
                          // const isShared = bookingInfo.shared
                          // const totalPayment = isShared
                          //   ? totalBeforeShare / 2
                          //   : totalBeforeShare

                          // bookingInfo.payable_amount.stalls.map(
                          //   (value, index) => {}
                          // )

                          let subtotal = 0
                          let gsttotal = 0
                          let addontotal = 0
                          let grandtotal = 0

                          stalls.map(val => {
                            if (
                              val.checked &&
                              val.payment_status === "pending"
                            ) {
                              subtotal += val.stall_cost
                              gsttotal += val.gst
                              // addontotal += val.add_on_cost
                            }
                          })
                          grandtotal = subtotal + gsttotal

                          const details = [
                            { label: "Seller Name", value: sellerName },
                            { label: "PVS Card Number", value: pvsCardNumber },
                            { label: "Stall Type", value: stallType },
                            { label: "Shared With", value: sharedWith },
                            { label: "Booking Date", value: bookingDate },
                            { label: "Booked By", value: bookedBy },
                          ]

                          return (
                            <>
                              {/* 🔹 Basic Info */}
                              {details.map((item, index) => (
                                <Col xs={12} md={6} key={index}>
                                  <div className="d-flex mb-2">
                                    <strong style={{ width: "125px" }}>
                                      {item.label}
                                    </strong>
                                    <span style={{ width: "20px" }}>:</span>
                                    <span className="text-cap">
                                      {item.value || "-"}
                                    </span>
                                  </div>
                                </Col>
                              ))}

                              {/* 🔹 Total Payment Table */}
                              <Col md={12} className="mt-3">
                                <h5 className="nom-title">
                                  Total Payment Details
                                </h5>
                                <table className="table table-bordered table-sm mb-0">
                                  <tbody>
                                    <tr>
                                      <th></th>
                                      <th>Stall No</th>
                                      <th>Base Price</th>
                                      <th>Discount (%)</th>
                                      <th>Discounted (₹)</th>
                                      <th>2 Sided Price</th>
                                      <th>Sharing</th>
                                      <th>Stall Cost</th>
                                      <th>GST (18%)</th>
                                      <th>Total</th>
                                    </tr>
                                    {stalls.map((value, index) => {
                                      return (
                                        <tr>
                                          <td>
                                            <Input
                                              type="checkbox"
                                              checked={value.checked}
                                              disabled={
                                                value.payment_status === "paid"
                                              }
                                              onChange={val => {
                                                changeCheckedStalls(index)
                                              }}
                                              className={
                                                value.payment_status === "paid"
                                                  ? "bg-success"
                                                  : ""
                                              }
                                            />
                                          </td>
                                          <td>{`${value.stall_number} (${value.seller_name})`}</td>
                                          <td>₹{value.base_price}</td>
                                          <td
                                            style={{
                                              display: "flex",
                                              flexDirection: "row",
                                              alignItems: "center",
                                              gap: 6,
                                            }}
                                          >
                                            <Input
                                              name="dicountPercent"
                                              className="form-control"
                                              style={{ width: 70 }}
                                              placeholder="0"
                                              type="number"
                                              id="dicount_percent"
                                              value={value.discount_percent}
                                              onChange={v => {
                                                if (v.target.value <= 100) {
                                                  handleStallDiscount(
                                                    index,
                                                    v.target.value
                                                  )
                                                }
                                              }}
                                            />{" "}
                                            %
                                          </td>
                                          <td>
                                            ₹{value.discount_amount || "0"}
                                          </td>
                                          <td>₹{value.two_sides_price}</td>
                                          <td>₹{value.add_on_cost}</td>
                                          <td>₹{value.stall_cost}</td>
                                          <td>₹{value.gst}</td>
                                          <td>₹{value.subtotal}</td>
                                        </tr>
                                      )
                                    })}
                                    {/* <tr className="table-primary fw-bold">
                                      <th className="text-end" colSpan={9}>
                                        Subtotal
                                      </th>
                                      <td className="text-end"> ₹{subtotal}</td>
                                    </tr>
                                    <tr className="table-primary fw-bold">
                                      <th className="text-end" colSpan={9}>
                                        Add-On Total
                                      </th>
                                      <td className="text-end">
                                        {" "}
                                        ₹{addontotal}
                                      </td>
                                    </tr>
                                    <tr className="table-primary fw-bold">
                                      <th className="text-end" colSpan={9}>
                                        Taxes Total
                                      </th>
                                      <td className="text-end"> ₹{gsttotal}</td>
                                    </tr> */}
                                    <tr className="table-primary fw-bold">
                                      <th className="text-end" colSpan={9}>
                                        Grand Total
                                      </th>
                                      <td className="text-start">
                                        {" "}
                                        ₹{grandtotal}
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </Col>
                            </>
                          )
                        })()}
                      </Row>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </div>
          </div>
          <div className="row">
            <div className="col-12 col-sm-12 col-lg-12">
              <Card>
                <CardBody className="pb-0">
                  <h4 className="nom-title">Billing Details</h4>
                  <div className="border-top mb-3 pb-2"></div>
                  <div className="row align-items-center">
                    <div className="col-12 col-sm-3">
                      <Label className="form-label gap-3 d-flex align-items-center">
                        Billing Info:
                        <span className="text-danger">*</span>
                      </Label>
                    </div>
                    <div className="col-12 col-sm-9">
                      <div className="form-check form-check-inline pl-4">
                        <Input
                          type="radio"
                          id="customRadioInline1"
                          name="customerType"
                          value="seller_1"
                          className="form-check-input"
                          onChange={e => {
                            sellerTypeChange(e.target.value)
                          }}
                          checked={
                            billingDetails.values.customerType === "seller_1"
                          }
                        />
                        <Label
                          className="form-check-label"
                          htmlFor="customRadioInline1"
                        >
                          Seller 1
                        </Label>
                      </div>
                      {bookingInfo.shared &&
                        bookingInfo.billing_details.length > 1 && (
                          <div className="form-check form-check-inline">
                            <Input
                              type="radio"
                              id="customRadioInline2"
                              name="customerType"
                              value="seller_2"
                              className="form-check-input"
                              onChange={e => {
                                sellerTypeChange(e.target.value)
                              }}
                              checked={
                                billingDetails.values.customerType ===
                                "seller_2"
                              }
                            />
                            <Label
                              className="form-check-label"
                              htmlFor="customRadioInline2"
                            >
                              Seller 2
                            </Label>
                          </div>
                        )}
                      {bookingInfo.shared &&
                        bookingInfo.billing_details.length === 3 && (
                          <div className="form-check form-check-inline">
                            <Input
                              type="radio"
                              id="customRadioInline2"
                              name="customerType"
                              value="seller_3"
                              className="form-check-input"
                              onChange={e => {
                                sellerTypeChange(e.target.value)
                              }}
                              checked={
                                billingDetails.values.customerType ===
                                "seller_3"
                              }
                            />
                            <Label
                              className="form-check-label"
                              htmlFor="customRadioInline2"
                            >
                              Seller 3
                            </Label>
                          </div>
                        )}
                    </div>
                  </div>
                  {/* Primary Contact */}
                  <div className="mb-3 row align-items-center mt-3">
                    <div className="col-12 col-sm-3">
                      <Label className="form-label" htmlFor="primary_contact">
                        Primary Contact &nbsp;
                        <span className="text-danger">*</span>
                      </Label>
                    </div>
                    <div className="col-12 col-sm">
                      <div className="row">
                        <div className="col-12 col-sm-6 mb-3">
                          <Input
                            name="firstName"
                            className="form-control"
                            placeholder="First Name"
                            type="text"
                            id="first_name"
                            value={billingDetails.values.firstName}
                            onChange={billingDetails.handleChange}
                            // onBlur={billingDetails.handleBlur}
                          />
                          {billingDetails.errors.firstName && (
                            <div className="text-danger small mt-1">
                              {billingDetails.errors.firstName}
                            </div>
                          )}
                        </div>
                        <div className="col-12 col-sm-6">
                          <Input
                            name="lastName"
                            className="form-control"
                            placeholder="Last Name"
                            id="last_name"
                            type="text"
                            value={billingDetails.values.lastName}
                            onChange={billingDetails.handleChange}
                            // onBlur={billingDetails.handleBlur}
                          />
                          {billingDetails.errors.lastName && (
                            <div className="text-danger small mt-1">
                              {billingDetails.errors.lastName}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="mb-3 row align-items-center mt-3">
                    <div className="col-12 col-sm-3">
                      <Label className="form-label" htmlFor="primary_contact">
                        Contact Info &nbsp;
                        {/* <span className="text-danger">*</span> */}
                      </Label>
                    </div>
                    <div className="col-12 col-sm">
                      <div className="row">
                        <div className="col-12 col-sm-6 mb-3">
                          <Input
                            name="email"
                            className="form-control"
                            type="email"
                            id="emailr"
                            value={billingDetails.values.email}
                            onChange={billingDetails.handleChange}
                          />
                          {billingDetails.errors.email && (
                            <div className="text-danger small mt-1">
                              {billingDetails.errors.email}
                            </div>
                          )}
                        </div>
                        <div className="col-12 col-sm-6">
                          <Input
                            name="mobileNo"
                            className="form-control"
                            type="number"
                            id="Mob_number"
                            value={billingDetails.values.mobileNo}
                            onChange={billingDetails.handleChange}
                          />
                          {billingDetails.errors.mobileNo && (
                            <div className="text-danger small mt-1">
                              {billingDetails.errors.mobileNo}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Company Info */}
                  <div className="mb-3 row align-items-center mt-3">
                    <div className="col-12 col-sm-3">
                      <Label className="form-label" htmlFor="primary_contact">
                        Company Info &nbsp;
                        {/* <span className="text-danger">*</span> */}
                      </Label>
                    </div>
                    <div className="col-12 col-sm">
                      <div className="row">
                        <div className="col-12 col-sm-6 mb-3">
                          <Input
                            name="companyName"
                            className="form-control"
                            type="text"
                            id="company_name"
                            placeholder="Company Name"
                            value={billingDetails.values.companyName}
                            onChange={billingDetails.handleChange}
                          />
                          {billingDetails.errors.companyName && (
                            <div className="text-danger small mt-1">
                              {billingDetails.errors.companyName}
                            </div>
                          )}
                        </div>
                        <div className="col-12 col-sm-6">
                          <Input
                            name="gstNumber"
                            className="form-control"
                            type="text"
                            id="gst_number"
                            placeholder="GST Number"
                            value={billingDetails.values.gstNumber}
                            onChange={e => {
                              billingDetails.setFieldValue(
                                "gstNumber",
                                e.target.value.toUpperCase()
                              )
                            }}
                          />
                          {billingDetails.errors.gstNumber && (
                            <div className="text-danger small mt-1">
                              {billingDetails.errors.gstNumber}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Address textarea */}
                  <div className="mb-3 row align-items-center">
                    <div className="col-12 col-sm-3">
                      <Label className="form-label" htmlFor="address">
                        Address &nbsp;
                      </Label>
                    </div>
                    <div className="col-12 col-sm-9">
                      <textarea
                        name="address"
                        className="form-control"
                        id="address"
                        rows="3"
                        value={billingDetails.values.address}
                        onChange={billingDetails.handleChange}
                        // onBlur={billingDetails.handleBlur}
                      ></textarea>
                      {billingDetails.errors.address && (
                        <div className="text-danger small mt-1">
                          {billingDetails.errors.address}
                        </div>
                      )}
                    </div>
                  </div>

                  <div className="mb-3 row align-items-center mt-3">
                    <div className="col-12 col-sm-3">
                      <Label className="form-label" htmlFor="primary_contact">
                        City, State & Pincode &nbsp;
                      </Label>
                    </div>
                    <div className="col-12 col-sm">
                      <div className="row">
                        <div className="col-12 col-sm-4 mb-3">
                          <Input
                            name="city"
                            className="form-control"
                            type="text"
                            id="city"
                            value={billingDetails.values.city}
                            onChange={billingDetails.handleChange}
                          />
                          {billingDetails.errors.city && (
                            <div className="text-danger small mt-1">
                              {billingDetails.errors.city}
                            </div>
                          )}
                        </div>
                        <div className="col-12 col-sm-4">
                          <Select
                            name="state"
                            value={billingDetails.values.state}
                            onChange={val => {
                              billingDetails.setFieldValue("state", val)
                            }}
                            options={stateOptions}
                            classNamePrefix="select2-selection"
                          />
                          {billingDetails.errors.state && (
                            <div className="text-danger small mt-1">
                              {billingDetails.errors.state}
                            </div>
                          )}
                        </div>
                        <div className="col-12 col-sm-4">
                          <Input
                            name="pincode"
                            className="form-control"
                            type="number"
                            id="pincode"
                            placeholder="Pincode"
                            value={billingDetails.values.pincode}
                            onChange={billingDetails.handleChange}
                            // onBlur={billingDetails.handleBlur}
                          />
                          {billingDetails.errors.pincode && (
                            <div className="text-danger small mt-1">
                              {billingDetails.errors.pincode}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </div>
          </div>

          <Card>
            <CardBody>
              <div className="d-flex flex-row justify-content-between">
                <h4 className="font-size-18 mb-3">Payment Method</h4>
                <h4 style={{ color: "lightcoral" }}>
                  {`Remaining Amount: ${(
                    payableTotal -
                      payments.reduce((sum, val) => sum + Number(val.amount), 0)
                  ).toFixed(2)}`}
                </h4>
              </div>
              <div className="border-top mb-2 pb-2"></div>
              <div className="row align-items-start">
                <div className="col-12 col-md-5">
                  <div className="mb-4">
                    <Label className="form-label" htmlFor="keywords">
                      Select Payment Mode
                    </Label>
                    <Select
                      id="payment_method"
                      options={paymentOptions}
                      value={paymentInfo.values.payment_method}
                      onChange={val => {

                        paymentInfo.setFieldValue("payment_method", val)
                      }}
                      classNamePrefix="select2-selection"
                    />
                    {paymentInfo.errors.payment_method && (
                      <div className="text-danger small mt-1">
                        {paymentInfo.errors.payment_method}
                      </div>
                    )}
                  </div>
                  {paymentInfo.values.payment_method.value ===
                    "Bank_Transfer" && (
                    <div className="group-bank-transfer">
                      <h4 className="font-size-16">Bank Details</h4>
                      <p className="font-size-16 mb-1">
                        PULA Exclusives Pvt Ltd
                      </p>
                      <p className="font-size-16 mb-1">50200031496410</p>
                      <p className="font-size-16 mb-1">IFSC: HDFC0001578</p>
                      <p className="font-size-16 mb-1">Branch: Kharadi Pune</p>
                      <p className="font-size-16 mb-1">Type: Current Account</p>
                    </div>
                  )}

                  {paymentInfo.values.payment_method.value === "UPI" && (
                    <div className="group-upi">
                      <h4 className="font-size-16 mb-3">UPI QR Code</h4>
                      <img src={QrCode} className="img-fluid" alt="QR Code" />
                    </div>
                  )}
                </div>
                <div className="col-12 col-md-6">
                  {paymentInfo.values.payment_method.value === "Cash" && (
                    <div className="row group-cash">
                      <div className="col-12 col-sm-6">
                        <div className="mb-3">
                          <Label className="form-label" htmlFor="cash_amount">
                            Amount:
                          </Label>
                          <Input
                            name="cash_amount"
                            className="form-control"
                            type="number"
                            id="cash_amount"
                            value={paymentInfo.values.amount}
                            onChange={e => {
                              paymentInfo.setFieldValue(
                                "amount",
                                e.target.value.toString()
                              )
                            }}
                            placeholder="Enter the amount"
                          />
                          {paymentInfo.errors.amount && (
                            <div className="text-danger small mt-1">
                              {paymentInfo.errors.amount}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  )}
                  {paymentInfo.values.payment_method.value ===
                    "Bank_Transfer" && (
                    <div className="row group-bank-transfer">
                      <div className="col-12 col-sm-6">
                        <div className="mb-3">
                          <Label className="form-label" htmlFor="bank_amount">
                            Amount:
                          </Label>
                          <Input
                            name="cash_amount"
                            className="form-control"
                            type="number"
                            id="cash_amount"
                            value={paymentInfo.values.amount}
                            onChange={e => {
                              paymentInfo.setFieldValue(
                                "amount",
                                e.target.value.toString()
                              )
                            }}
                            placeholder="Enter the amount"
                          />
                          {paymentInfo.errors.amount && (
                            <div className="text-danger small mt-1">
                              {paymentInfo.errors.amount}
                            </div>
                          )}
                        </div>
                      </div>

                      <div className="col-12 col-sm-6">
                        <Label
                          className="form-label"
                          htmlFor="bank_transaction_id"
                        >
                          Transaction ID:
                        </Label>
                        <Input
                          name="upi_transaction_id"
                          className="form-control"
                          type="text"
                          id="upi_transaction_id"
                          placeholder="Enter Transaction ID"
                          value={paymentInfo.values.transaction_id}
                          onChange={e => {
                            paymentInfo.setFieldValue(
                              "transaction_id",
                              e.target.value
                            )
                          }}
                        />
                        {paymentInfo.errors.transaction_id && (
                          <div className="text-danger small mt-1">
                            {paymentInfo.errors.transaction_id}
                          </div>
                        )}
                      </div>
                    </div>
                  )}
                  {paymentInfo.values.payment_method.value === "UPI" && (
                    <div className="row group-bank-transfer">
                      <div className="col-12 col-sm-6">
                        <div className="mb-3">
                          <Label className="form-label" htmlFor="upi_amount">
                            Amount:
                          </Label>
                          <Input
                            name="cash_amount"
                            className="form-control"
                            type="number"
                            id="cash_amount"
                            value={paymentInfo.values.amount}
                            onChange={e => {
                              paymentInfo.setFieldValue(
                                "amount",
                                e.target.value.toString()
                              )
                            }}
                            placeholder="Enter the amount"
                          />
                          {paymentInfo.errors.amount && (
                            <div className="text-danger small mt-1">
                              {paymentInfo.errors.amount}
                            </div>
                          )}
                        </div>
                      </div>

                      <div className="col-12 col-sm-6">
                        <Label
                          className="form-label"
                          htmlFor="upi_transaction_id"
                        >
                          Transaction ID:
                        </Label>
                        <Input
                          name="upi_transaction_id"
                          className="form-control"
                          type="text"
                          id="upi_transaction_id"
                          placeholder="Enter Transaction ID"
                          value={paymentInfo.values.transaction_id}
                          onChange={e => {
                            paymentInfo.setFieldValue(
                              "transaction_id",
                              e.target.value
                            )
                          }}
                        />
                        {paymentInfo.errors.transaction_id && (
                          <div className="text-danger small mt-1">
                            {paymentInfo.errors.transaction_id}
                          </div>
                        )}
                      </div>
                    </div>
                  )}
                </div>
                <div className="col-12 col-md-1">
                  <div className="d-flex justify-content-center mt-2">
                    <Button
                      color="primary"
                      size="md"
                      className="mt-3 font-size-17"
                      onClick={() => {
                        paymentInfo.handleSubmit()
                      }}
                    >
                      <i className="ion ion-md-add"></i>
                    </Button>
                  </div>
                </div>
              </div>

              {/* 🔹 Paid Payment Table */}
              <div className="table-responsive mt-3">
                <table className="table table-bordered table-striped table-sm">
                  <thead className="table-light">
                    <tr>
                      <th>#</th>
                      <th>Payment Type</th>
                      <th>Amount (₹)</th>
                      <th>Transaction ID</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {payments.map((payment, index) => (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td>{payment.payment_method}</td>
                        <td>₹{payment.amount.toLocaleString()}</td>
                        <td>{payment.transaction_id}</td>
                        <td>
                          <Button
                            color="danger"
                            size="sm"
                            onClick={() => removePayment(index)}
                            title="Delete"
                            aria-label="Delete payment"
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="14"
                              height="14"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              strokeWidth="2"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              style={{ marginRight: 6 }}
                            >
                              <polyline points="3 6 5 6 21 6"></polyline>
                              <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"></path>
                              <path d="M10 11v6"></path>
                              <path d="M14 11v6"></path>
                              <path d="M9 6V4a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2"></path>
                            </svg>
                          </Button>
                        </td>
                      </tr>
                    ))}

                    {/* 🔹 Total Row */}
                    <tr className="table-primary fw-bold">
                      <td colSpan="2" className="text-end">
                        Total Paid
                      </td>
                      <td colSpan="4">
                        ₹
                        {payments
                          .reduce((sum, val) => sum + Number(val.amount), 0)
                          .toLocaleString()}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </CardBody>
          </Card>

          <div className="d-flex justify-content-center mt-4">
            <Button
              type="submit"
              color="primary"
              size="md"
              className="mt-3 font-size-16"
              disabled={addBookingPaymentScreen.loading}
              variant={addBookingPaymentScreen.loading ? "default" : "active"}
            >
              {addBookingPaymentScreen.loading ? "Processing..." : "Submit"}
            </Button>
          </div>
        </Form>
      </div>
      <ErrorPopup
        isOpen={isErrorOpen}
        toggle={() => setIsErrorOpen(!isErrorOpen)}
        title="Error"
        message={isErrorMessage}
      />
      <PageLoader open={addBookingPaymentScreen.loading} />
    </div>
  ) : null
}

export default BazaarPayment
